import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

/** 
    $A api 接口请求地址封装
    $C config 系统配置项
    $D dateUtil 时间处理类
    $F file 上传，导出文件处理类
    $H http axios 请求封装
    $S service 共通业务处理
*/
import http from './utils/http';
import api from './config/api-config';
import config from './config/config';
import utils from './utils/utils';
import service from './utils/service';
import dateUtil from './utils/dateUtils';
import * as echarts from 'echarts'

import { Message } from 'element-ui'
import dayjs from "dayjs"
Vue.prototype.$dayjs = dayjs;
Vue.prototype.$echarts = echarts;

Vue.prototype.$A = api; //全局注册请求地址
Vue.prototype.$C = config; //全局静态文件
Vue.prototype.$D = dateUtil; //全局日期
Vue.prototype.$H = http; //全局请求数据
Vue.prototype.$U = utils; //全局通用方法
Vue.prototype.$S = service; //全局

// import 'lib-flexible';

// 全局css
import './assets/css/common.css';

// 引入element-ui
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import '../theme/index.css'
Vue.use(ElementUI);
// Iview
import iView from 'iview';
import 'iview/dist/styles/iview.css';
Vue.use(iView);

// 全局组件注册
import zdTable from './components/table/index.vue';
Vue.component(zdTable.name, zdTable);
// 列表的分页
import zdpagination from './components/table/table-pagination.vue';
Vue.component(zdpagination.name, zdpagination);
// 面包屑
import ZDBreadCrumb from './components/bread-crumb/index.vue';
Vue.component(ZDBreadCrumb.name, ZDBreadCrumb);
// 区域树形选择
import ZDAreaTree from './components/area-tree/index.vue';
Vue.component(ZDAreaTree.name, ZDAreaTree);
// 区域级联选择
import ZDAreaSelect from './components/area-select/index.vue';
Vue.component(ZDAreaSelect.name, ZDAreaSelect);
// 列表页高级查询
import ZDListQuerys from './components/list-querys/index.vue';
Vue.component(ZDListQuerys.name, ZDListQuerys);
//区域插件
import VDistpicker from 'v-distpicker'
Vue.component('v-distpicker', VDistpicker);

import { numberToCurrencyNo } from '@/utils/numberToCurrency'
// 配置全局过滤器，实现数字千分位格式
Vue.filter('numberToCurrency', numberToCurrencyNo)

import { numFilter } from '@/utils/numFilter'
// 配置全局过滤器，实现数字千分位格式
Vue.filter('numFilter', numFilter)



// // 列表的新增按钮
// import ZDAddBtn from './components/buttons/add-button.vue';
// Vue.component(ZDAddBtn.name,ZDAddBtn);
// // 列表的编辑按钮
// import ZDEditBtn from './components/buttons/edit-button.vue';
// Vue.component(ZDEditBtn.name,ZDEditBtn);
// // 列表的导出按钮
// import ZDFileTemplateBtn from './components/buttons/file-template-button.vue';
// Vue.component(ZDFileTemplateBtn.name,ZDFileTemplateBtn);
// // 列表的导入按钮
// import ZDFileUploadBtn from './components/buttons/file-upload-button.vue';
// Vue.component(ZDFileUploadBtn.name,ZDFileUploadBtn);
// // 明细的文件上传
// import ZDDetailFileUploadBtn from './components/buttons/detail-file-upload-button.vue';
// Vue.component(ZDDetailFileUploadBtn.name,ZDDetailFileUploadBtn);
// // 详情页 标题
// import ZDDetailTitle from './components/detail/detail-title.vue';
// Vue.component(ZDDetailTitle.name,ZDDetailTitle);

Vue.config.productionTip = false;
const PAGE_IDLE_TIMEOUT = 15 * 60 * 1000
let pageHiddenAt = 0;
const ENABLE_IDLE_AUTO_REFRESH = process.env.NODE_ENV === 'production';

// 路由前置操作
router.beforeEach((to, from, next) => {
    if (to.name != "login" && to.name.indexOf('h5') < 0) {
        if (to.name == 'scanningCode' || to.name == 'scanningCodeByPortable') {
            next()
            return
        }
        if (!store.state.token) {
            router.replace('/');
            // Message.error({
            // 	message: "没有访问权限!"
            // })
        } else {
            next();
        }
    }
    else {
        next();
    }
});

new Vue({
    router,
    store,
    render: h => h(App),
    mounted() {
        this.$store.commit('updateMenuList');
        this.$store.commit('setMenuCollapse', false);
        document.addEventListener('visibilitychange', () => {
            if (!ENABLE_IDLE_AUTO_REFRESH) return;
            if (document.hidden) {
                pageHiddenAt = Date.now();
                return;
            }
            if (!pageHiddenAt) return;
            const idleMs = Date.now() - pageHiddenAt;
            pageHiddenAt = 0;
            if (idleMs >= PAGE_IDLE_TIMEOUT && this.$route.name !== 'login') {
                window.location.reload();
            }
        });
    },
}).$mount('#app')